__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@lllverse-dhsn/host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "4.6.2", () => (Promise.all([__webpack_require__.e(3704), __webpack_require__.e(8974), __webpack_require__.e(1957), __webpack_require__.e(6927), __webpack_require__.e(3602), __webpack_require__.e(2895)]).then(() => (() => (__webpack_require__(81957))))));
			register("@life-line-lab/components-react", "1.0.43", () => (Promise.all([__webpack_require__.e(4052), __webpack_require__.e(6927), __webpack_require__.e(4819)]).then(() => (() => (__webpack_require__(74052))))));
			register("@zxing/library", "0.18.6", () => (__webpack_require__.e(28).then(() => (() => (__webpack_require__(20028))))));
			register("axios", "0.21.1", () => (__webpack_require__.e(9644).then(() => (() => (__webpack_require__(89644))))));
			register("classnames", "2.3.1", () => (__webpack_require__.e(2779).then(() => (() => (__webpack_require__(72779))))));
			register("crypto-js", "4.1.1", () => (Promise.all([__webpack_require__.e(6023), __webpack_require__.e(633)]).then(() => (() => (__webpack_require__(36023))))));
			register("i18next-browser-languagedetector", "6.1.2", () => (__webpack_require__.e(790).then(() => (() => (__webpack_require__(60790))))));
			register("i18next-http-backend", "1.3.0", () => (__webpack_require__.e(1391).then(() => (() => (__webpack_require__(1391))))));
			register("i18next", "20.3.5", () => (Promise.all([__webpack_require__.e(5499), __webpack_require__.e(4786)]).then(() => (() => (__webpack_require__(45499))))));
			register("papaparse", "5.3.1", () => (__webpack_require__.e(286).then(() => (() => (__webpack_require__(90286))))));
			register("react-custom-scrollbars-2", "4.4.0", () => (Promise.all([__webpack_require__.e(7913), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(7913))))));
			register("react-device-detect", "1.17.0", () => (Promise.all([__webpack_require__.e(3657), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(23657))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(8316), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(28316))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(8671), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(37886))))));
			register("react-i18next", "11.11.4", () => (Promise.all([__webpack_require__.e(6927), __webpack_require__.e(2428)]).then(() => (() => (__webpack_require__(72428))))));
			register("react-quill", "1.3.5", () => (Promise.all([__webpack_require__.e(6110), __webpack_require__.e(8617), __webpack_require__.e(6927), __webpack_require__.e(4819), __webpack_require__.e(2965)]).then(() => (() => (__webpack_require__(8617))))));
			register("react-responsive", "9.0.0-beta.6", () => (Promise.all([__webpack_require__.e(7160), __webpack_require__.e(6927)]).then(() => (() => (__webpack_require__(17160))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(2817), __webpack_require__.e(6927), __webpack_require__.e(9874)]).then(() => (() => (__webpack_require__(12817))))));
			register("react-webcam", "5.2.4", () => (Promise.all([__webpack_require__.e(6927), __webpack_require__.e(8709)]).then(() => (() => (__webpack_require__(28709))))));
			register("react", "17.0.2", () => (__webpack_require__.e(2784).then(() => (() => (__webpack_require__(2784))))));
			register("recoil", "0.1.3", () => (Promise.all([__webpack_require__.e(2732), __webpack_require__.e(6927), __webpack_require__.e(4819)]).then(() => (() => (__webpack_require__(2732))))));
			register("uuid", "8.3.2", () => (__webpack_require__.e(1614).then(() => (() => (__webpack_require__(21614))))));
			register("yup", "0.32.9", () => (Promise.all([__webpack_require__.e(6110), __webpack_require__.e(8253), __webpack_require__.e(8049)]).then(() => (() => (__webpack_require__(88253))))));
			initExternal(86143);
			initExternal(49342);
			initExternal(90706);
			initExternal(59888);
			initExternal(13445);
			initExternal(86285);
			initExternal(68741);
			initExternal(43313);
			initExternal(22084);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};